import styled from 'styled-components';
import { respondTo } from '../../../styles/_respondTo';

export const ProjectContainer = styled.div`
  display: grid;
  gap: 30px;
  padding: 10px;
  border-radius: 6px;
  grid-template-columns: 1fr;

  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
  grid-template-columns: 1fr 1fr;
  `}

  ${respondTo.xl`
  `}

`

export const DivWithBorder = styled.div`
  padding: 10px;
`